import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/linked-to/projects")({
  staticData: {
    title: "linkedTo.project.title",
  },
});
